module.exports = __webpack_public_path__ + "img/wrench.0b1b525c.svg";